module.exports = __webpack_public_path__ + "static/listen-49586cd89e91bf452f797f4ed346f789.mp4";